import React, {Component} from 'react';
import PropTypes from 'prop-types';

class TableActions extends Component {
  render() {
    return (
      <div className='actions'>
        <i className="fa fa-cog hafele-red" style={{fontSize: '25px', cursor: 'pointer', marginTop: '8px'}} data-toggle="dropdown"/>
        <ul className="dropdown-menu in-table dropup" role="menu" style={{left: 'auto', right: 0, marginRight: '5px'}}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

TableActions.propTypes = {
  children: PropTypes.node,
  identifier: PropTypes.any,
};
TableActions.defaultProps = {};

export default TableActions;
